// src/App.js
import React, { useState } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { darkTheme, lightTheme } from './components/theme';
import { BrowserRouter, Router, Routes, Route, Navigate } from 'react-router-dom';

import AnalyticsTracker from 'components/AnalyticsTracker';
// 컴포넌트 import
import NavBar from './components/NavBar';
import MainePage from './pages/MainPage';
import EmailReject from './pages/EmailReject';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ExternalRedirect from './components/ExternalRedirect';
import Vote from './pages/Vote';


// 명령어 페이지 모음
import Overview from './pages/docs/overview';
import InfoCommand from './pages/docs/overwatch/info';
import HeroCommand from './pages/docs/overwatch/hero';
import OwtierCommand from 'pages/docs/overwatch/tier';
import TeamCommand from './pages/docs/overwatch/team';
import AnaCommand from './pages/docs/overwatch/analyze';
import MealCommand from './pages/docs/meal/check';
import HelpCommand from './pages/docs/etc/help';
import MagicCommand from 'pages/docs/etc/MagicConch';
import PrefixCommand from './pages/docs/etc/prefix';
import CheckprefixCommand from './pages/docs/etc/checkprefix';
import CoinCommand from './pages/docs/game/coin';
import GetCoinCommand from './pages/docs/game/getcoin';
import VoteCommand from './pages/docs/game/vote';
import StateCommand from 'pages/docs/game/state';
import DobakCommand from './pages/docs/game/dobak';
import DiceCommand from './pages/docs/game/dice';
import RspCommand from './pages/docs/game/rsp';
import GspCommand from './pages/docs/game/grp'
import BlackJackCommand from './pages/docs/game/blackjack';
import RankCommand from './pages/docs/game/rank';
import MealReCommand from 'pages/docs/meal/register';
import PriceCommand from './pages/docs/tarkov/price';
import MapCommand from './pages/docs/tarkov/map';
import OwregisterCommand from 'pages/docs/overwatch/owregister';

import CustomCheckCommand from 'pages/docs/custom/check';
import CustomEditCommand from 'pages/docs/custom/edit';
import CreateCommand from 'pages/docs/custom/create';
import DeleteCommand from 'pages/docs/custom/delete';
import CustomSettingCommand from 'pages/docs/custom/setting';


function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : true; // 없으면 기본 다크
  });

  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem('theme', newMode ? 'dark' : 'light');
  };

  const theme = isDarkMode ? darkTheme : lightTheme;
  const discordInviteUrl = "https://discord.gg/tt92Md6Y4Q";
  const discordBotUrl = "https://discord.com/oauth2/authorize?client_id=996765559603613747"

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AnalyticsTracker />
        <NavBar toggleTheme={toggleTheme} isDarkMode={isDarkMode} />

        <Routes>
          <Route path="/" element={<MainePage />} />
          <Route path="/email" element={<EmailReject />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/vote" element={<Vote />} />

          <Route path="/invite" element={<ExternalRedirect to={discordBotUrl} />}/>
          <Route path="/discord" element={<ExternalRedirect to={discordInviteUrl} />}/>

          {/*명령어 모음*/}
          <Route path="/docs" element={<Navigate replace to="/docs/overview" />} />       {/*element={<Navigate replace to="/docs/overwatch/hero" />} />            element={<DocsIndex />} />    */}
          <Route path="/docs/overview" element={<Overview />} /> 
          <Route path="/docs/overwatch" element={<Navigate replace to="/docs/overwatch/hero" />} />
          <Route path="/docs/overwatch/info" element={<InfoCommand />} />
          <Route path="/docs/overwatch/hero" element={<HeroCommand />} />
          <Route path="/docs/overwatch/owregister" element={<OwregisterCommand />} />
          <Route path="/docs/overwatch/tier" element={<OwtierCommand />} />
          <Route path="/docs/overwatch/team" element={<TeamCommand />} />
          <Route path="/docs/overwatch/analyze" element={<AnaCommand />} />

          <Route path="/docs/meal" element={<Navigate replace to="/docs/meal/register" />} />
          <Route path="/docs/meal/register" element={<MealReCommand />} />
          <Route path="/docs/meal/check" element={<MealCommand />} />

          <Route path="/docs/etc" element={<Navigate replace to="/docs/etc/help" />} />
          <Route path="/docs/etc/help" element={<HelpCommand />} />
          <Route path="/docs/etc/magicconch" element={<MagicCommand />} />
          <Route path="/docs/etc/prefix" element={<PrefixCommand />} />
          <Route path="/docs/etc/checkprefix" element={<CheckprefixCommand />} />

          <Route path="/docs/game" element={<Navigate replace to="/docs/game/coin" />} />
          <Route path="/docs/game/coin" element={<CoinCommand />} />
          <Route path="/docs/game/getcoin" element={<GetCoinCommand />} />
          <Route path="/docs/game/vote" element={<VoteCommand />} />
          <Route path="/docs/game/state" element={<StateCommand />} />
          <Route path="/docs/game/dobak" element={<DobakCommand />} />
          <Route path="/docs/game/dice" element={<DiceCommand />} />
          <Route path="/docs/game/rsp" element={<RspCommand />} />
          <Route path="/docs/game/grp" element={<GspCommand />} />
          <Route path="/docs/game/blackjack" element={<BlackJackCommand />} />
          <Route path="/docs/game/rank" element={<RankCommand />} />

          <Route path="/docs/custom" element={<Navigate replace to="/docs/custom/check" />} />
          <Route path="/docs/custom/check" element={<CustomCheckCommand />} />
          <Route path='/docs/custom/create' element={<CreateCommand />}/>
          <Route path='/docs/custom/edit' element={<CustomEditCommand />}/>
          <Route path='/docs/custom/delete' element={<DeleteCommand />}/>
          <Route path='/docs/custom/setting' element={<CustomSettingCommand />}/>

          <Route path="/docs/tarkov" element={<Navigate replace to="/docs/tarkov/price" />} />
          <Route path="/docs/tarkov/price" element={<PriceCommand />} />
          <Route path="/docs/tarkov/map" element={<MapCommand />} />

        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;